import { LogicModel } from 'api/dto/Logic.dto';
import { PageItemKind } from 'model/PageItemKind';
import { LangCodeEnum } from 'shared/enums/LangCodeEnum';
import { PageItemApi } from 'api/PageItemApi';
import { pageItemMapper } from 'container/pageItemMapper';

export type PageItemModel = {
  id?: number;
  position?: number;
  kind?: PageItemKind;
  logic?: LogicModel;
  page?: number;
  benchmarkItemId?: number;
  trendItemId?: number;
  locale?: LangCodeEnum;
};

export function mapPageItemDtoToModel(dto: PageItemApi.Entry): PageItemModel {
  return pageItemMapper.deserialize(dto);
}

export function mapPageItemModelToDto(model: PageItemModel): PageItemApi.Entry {
  return pageItemMapper.serialize(model);
}

export namespace PageItemModel {
  export const REGULAR_PROJECT_QUESTION_KINDS: PageItemKind[] = [
    PageItemKind.QuestionOpinion,
    PageItemKind.QuestionRadioButton,
    PageItemKind.QuestionCheckbox,
    PageItemKind.QuestionCAS,
    PageItemKind.QuestionCommentsBox,
    PageItemKind.QuestionForm,
    PageItemKind.QuestionDemographic,
    PageItemKind.QuestionConsent,
  ];

  export const PULSE_PROJECT_QUESTION_KINDS: PageItemKind[] = [
    PageItemKind.QuestionOpinion,
    PageItemKind.QuestionRadioButton,
    PageItemKind.QuestionCheckbox,
    PageItemKind.QuestionCommentsBox,
    PageItemKind.QuestionDemographic,
  ];
}
